import { createAsyncThunk } from '@reduxjs/toolkit';
import PropertiesResource from 'api/service/PropertiesResource';

export const listAllProperties = createAsyncThunk('properties/listAllProperties', async (_, { rejectWithValue }) => {
  const propertiesResource = new PropertiesResource();
  const params = { orderBy: 'name', size: 15, offset: 0, includes: 'user' };

  const { status, data } = await propertiesResource.list(params);

  if (status === 200) {
    return { data: data || [], offset: 15 };
  }
  return rejectWithValue('Properties not found');
});

export const listAllPropertiesNext = createAsyncThunk(
  'properties/listAllPropertiesNext',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { offset = 0 } = initialData || {};
    const params = { orderBy: 'name', size: 15, offset: offset || 0, includes: 'user' };

    const { status, data } = await propertiesResource.list(params);

    if (status === 200) {
      return { data: data || [], offset: offset + 15 };
    }
    return rejectWithValue('Properties not found');
  }
);

export const searchProperties = createAsyncThunk(
  'properties/searchProperties',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { query = '' } = initialData || {};
    const params = { orderBy: 'name', size: 5, offset: 0, ...(query ? { query } : {}) };
    const response = await propertiesResource.search(params);
    if (response?.status === 200) {
      return { data: response?.data || [], offset: 5 };
    }
    return rejectWithValue('Properties not found');
  }
);

export const searchPropertiesNext = createAsyncThunk(
  'properties/searchPropertiesNext',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { offset = 0 } = initialData || {};
    const { query = '' } = initialData || {};
    const params = { orderBy: 'name', access: 'Write', size: 5, offset: offset || 0, ...(query ? { query } : {}) };
    const response = await propertiesResource.search(params);
    if (response?.status === 200) {
      return { data: response?.data || [], offset: offset + 5 };
    }
    return rejectWithValue('Properties not found');
  }
);
